import cn from 'classnames';
import RichText from 'src/components/BaseHelpers/RichText';
import Text from 'src/components/BaseHelpers/Text';

import { hasNonWhiteTheme } from 'src/utils/hasNonWhiteTheme';

import { ComponentProps } from 'src/types/component-props';
import { CoreFlexibleListData } from 'src/types/components';

import CrossLink from 'components/BaseHelpers/CrossLink';
import FeaturedItem from 'components/BaseHelpers/FeaturedItem';

import styles from './CoreFlexibleList.module.scss';

export type CoreFlexibleListProps = ComponentProps & CoreFlexibleListData;

const CoreFlexibleList = ({ fields }: CoreFlexibleListProps): JSX.Element => {
  const { header, list, showFeaturedItem, featuredItem, theme, anchorTag } = fields;

  const hasDarkerBackground = hasNonWhiteTheme(theme) && 'spacer--with-vertical-padding';
  const themeClass = `theme--${theme}`;

  return (
    <section
      id={anchorTag}
      className={cn(styles.coreFlexibleList, styles[themeClass], 'spacer', hasDarkerBackground)}
    >
      <div className={cn('container', 'container--true-1440')}>
        <div className={cn(styles.main)}>
          <div className={cn(styles.header)}>
            {!!header.eyebrow && (
              <div className={cn(styles.eyebrow)}>
                <Text field={header.eyebrow} />
              </div>
            )}
            {header.heading && (
              <h2 className={cn(styles.heading)}>
                <Text field={header.heading} />
              </h2>
            )}
            {header.description && <RichText field={header.description} styleType="p1" />}
          </div>

          {showFeaturedItem && <FeaturedItem {...featuredItem} />}
          <ul className={styles.list}>
            {list.map((item, index) => {
              return (
                <li key={`DList-${index}`}>
                  <CrossLink {...item} type="large" />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CoreFlexibleList;
